(function(){
    'use strict'

    angular.module('app.login')
    .factory('LoginService', LoginService);

    LoginService.$inject = ['$http', '$q', 'apiSettings'];

    function LoginService($http, $q, apiSettings) {

        var api = {
            login: login,
            refreshToken: refreshToken,
            getLoginInfo: getLoginInfo
        };

        return api;

        function login(userData){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'token',  
                method: 'POST',  
                data: $.param({  
                    grant_type: userData.grant_type,  
                    username: userData.userName,  
                    password: userData.password  
                }),  
                headers: { 'Content-Type': 'application/x-www-form-urlencoded',
                            'Access-Control-Allow-Origin' : '*',
                            'Access-Control-Allow-Methods' : '*',
                            'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept, Authorization, X-Auth-Token',
                            }  
            });  
            return response;
        };

        function refreshToken(refreshToken, grantType){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'token',  
                method: 'POST',  
                data: $.param({  
                    grant_type: grantType,  
                    refresh_token: refreshToken
                }),  
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }  
            });  
            return response;
        };

        function getLoginInfo(){

            var url = apiSettings.apiBaseUrl + 'api/usuarios/login-info';
            
            return $http.get(url)
            .then(getLoginInfoSuccess, getLoginInfoError);

            function getLoginInfoSuccess(response){
                return response.data;
            };

            function getLoginInfoError(error) {
                return $q.reject(error);
            }
        };

    };

})();